export default function ShortcutGuide() {
	return null;
	// return (
	// 	<div className="fixed top-0 left-0 h-screen w-screen bg-bg-primary/50 backdrop-blur-sm">
	// 		{/* Shortcuts */}
	// 		{/* Customize Send / Draft Send / Multiline */}
	// 		{/* Onboard as a Power User / Simple User */}
	// 	</div>
	// );
}
